"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuOrderLogToJSON = exports.MenuOrderLogFromJSONTyped = exports.MenuOrderLogFromJSON = void 0;
var _1 = require("./");
function MenuOrderLogFromJSON(json) {
    return MenuOrderLogFromJSONTyped(json, false);
}
exports.MenuOrderLogFromJSON = MenuOrderLogFromJSON;
function MenuOrderLogFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'date': json['date'],
        'status': (0, _1.MenuOrderStatusFromJSON)(json['status']),
    };
}
exports.MenuOrderLogFromJSONTyped = MenuOrderLogFromJSONTyped;
function MenuOrderLogToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'date': value.date,
        'status': (0, _1.MenuOrderStatusToJSON)(value.status),
    };
}
exports.MenuOrderLogToJSON = MenuOrderLogToJSON;
